import React from "react";
import { Link } from "react-router-dom";

export function Hero() {
  return (
    <section className="hero">
      <div className="hero-overlay" />
      <div className="hero-inner">
        <div className="hero-text">
          <p className="hero-eyebrow">Dobrodošli u RESTORAN KRČMA</p>
          <h1 className="hero-title">
            Ukus tradicije u Kragujevcu!
          </h1>
          <p className="hero-subtitle">
            U restoranu Krčma očekuje vas autentična ponuda domaće kuhinje,
            pripremljene sa posebnom pažnjom i u duhu srpske tradicije.
            Idealno mesto za porodične ručkove, poslovne sastanke i sve vrste proslava.
          </p>
          <div className="hero-actions">
            <a href="tel:034354571" className="btn btn-primary">
              POZOVITE NAS
            </a>
            <Link to="/restoran" className="btn btn-ghost">
              Meni i cenovnik
            </Link>
          </div>
          <div className="hero-meta">
            <div>
              <span className="meta-label">Radno vreme</span>
              <span className="meta-value">
                Pon–Sub: 09–23 h
                <br />
                Nedeljom 10–22 h
              </span>
            </div>
            <div>
              <span className="meta-label">Telefon</span>
              <a href="tel:034354571" className="meta-value">
                034 354-571
              </a>
            </div>
            <div>
              <span className="meta-label">Lokacija</span>
              <span className="meta-value">
                Kraljevačkog bataljona 267, Kragujevac
              </span>
            </div>
          </div>
        </div>
        <div className="hero-card">
          <div
            className="hero-card-image"
            role="img"
            aria-label="Restoran Krčma – enterijer i atmosfera"
          />
          <div className="hero-card-content">
            <h2>Banket sala i smeštaj</h2>
            <p>
              Savršeno mesto za venčanja, rođendane, krštenja i poslovne
              događaje uz mogućnost noćenja za goste.
            </p>
            <ul>
              <li>Do 190 zvanica u banket sali</li>
              <li>
                Obezbeđen parking prostor, popločan Behatonom, za 180 vozila.
              </li>
              <li>Prenoćište nudi smeštaj od 27 ležaja</li>
            </ul>
            <a href="#banket" className="hero-link">
              Detaljnije o banket sali
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

